import React, { createContext, useContext, useMemo, useState } from "react";

import { UsersContextProps, UsersContextValues } from "../types/contexts";

import { AsyncStatuses } from "../../../../types/shared";

const UsersContext = createContext<UsersContextValues | null>(null);

export const useUsersContext = () => {
    const context = useContext(UsersContext);
    if (!context) {
        throw new Error("useUsersContext must be used within a UsersProvider");
    }
    return context;
};

export const UsersProvider: React.FC<UsersContextProps> = props => {
    const { children, isAddingUser, setIsAddingUser } = props;

    const [fetchStatus, setFetchStatus] = useState<AsyncStatuses>(undefined);
    const [userId, setUserId] = useState<number | undefined>(undefined);

    const contextValue = useMemo(
        () => ({
            fetchStatus,
            setFetchStatus,
            userId,
            setUserId,
            isAddingUser,
            setIsAddingUser,
        }),
        [userId, isAddingUser, fetchStatus],
    );

    return (
        <UsersContext.Provider value={contextValue}>
            {children}
        </UsersContext.Provider>
    );
};
